
import { defineComponent, ref, reactive, toRefs, onMounted, computed, onUnmounted } from 'vue'
import { InfoCircleOutlined } from '@ant-design/icons-vue'
import router from '@/router/index'
import { useRoute } from 'vue-router'
import Navatop from '@/components/navtop.vue'
import api from '@/api/allApi'
import Table from '@/components/table.vue'
import globalsets from '@/utils/globalsets'
import ws from '../../websocket/index'
export default defineComponent({
  props: {
    itemdata: {
      type: Object,
      default: () => {
        return {}
      }
    },
    pageSourceData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    theme: {

      type: String,
      default: () => {
        return ''
      }
    }
  },
  components: { Table, InfoCircleOutlined },
  setup(props, context) {
    const route = useRoute()
    const pageData: any = reactive({
      list: [],
      list2: [],
      tooltip: {},
      overflow: {},
      EndDate: '',
      EndDate1: '',
      getPopupContainer: () => document.querySelector('.zxzbul li'),
      spinning: true,
      lastPrice: null
    })
    pageData.list = computed(() => {
      return setlist()
    })
    function setlist() {
      const _data = (props.pageSourceData || {}).Fin
      if (!(_data || {}).P1) return []
      pageData.EndDate = ((_data || {} || {}).P1 || {}).EndDate
      let list: any = []
      list = [
        {
          key: '',
          name: '基本每股收益 (元)',
          num: ((_data || {} || {}).P3 || {}).BasicEPS || null,
          tag: _data.P3.Tag === 1 ? '快' : null,
          time: _data.P3.EndDate
        },
        {
          key: '',
          name: '每股净资产 (元)',
          num: ((_data || {} || {}).P2 || {}).NAPS,
          tag: _data.P2.Tag === 1 ? '快' : null,
          time: _data.P2.EndDate
        },
        {
          key: '',
          name: '每股经营现金流 (元)',
          num: ((_data || {} || {}).P3 || {}).OperCashFlowPS,
          tag: _data.P3.Tag === 1 ? '快' : null,
          time: _data.P3.EndDate
        },
        {
          key: '',
          name: '扣非每股收益 (元)',
          num: ((_data || {} || {}).P3 || {}).EPSCut,
          tag: _data.P3.Tag === 1 ? '快' : null,
          time: _data.P3.EndDate
        },
        {
          key: '',
          name: '每股公积金 (元)',
          num: ((_data || {} || {}).P1 || {}).PerCPF
        },
        {
          key: '',
          name: '市盈率 (动态)',
          num: (((_data || {} || {}).P1 || {}).TotalShares * pageData.lastPrice) / (((_data || {} || {}).P1 || {}).ReportProfit * 100000000),
          tip: '总市值/预估全年净利润',
          fixed: 2
        },
        {
          key: '',
          name: '稀释每股收益 (元)',
          num: ((_data || {} || {}).P3 || {}).DilutedEPS,
          tag: _data.P3.Tag === 1 ? '快' : null,
          time: _data.P3.EndDate
        },
        {
          key: '',
          name: '每股未分配利润 (元)',
          num: ((_data || {} || {}).P1 || {}).PerUndProf
        },
        {
          key: '',
          name: '市盈率 (TTM)',
          num: (((_data || {} || {}).P1 || {}).TotalShares * pageData.lastPrice) / ((_data || {} || {}).P1 || {}).YearProfitTTM,
          tip: '总市值/最近4个季度净利润之和',
          fixed: 2
        },
        {
          key: '',
          name: '总股本 (股)',
          num: ((_data || {} || {}).P1 || {}).TotalShares,
          slots: { customRender: 'peopleCount' }
        },
        {
          key: '',
          name: '流通股本 (股)',
          num: ((_data || {} || {}).P1 || {}).FloatShare,
          slots: { customRender: 'peopleCount' }
        },
        {
          key: '',
          name: '市盈率 (静态)',
          num: (((_data || {} || {}).P1 || {}).TotalShares * pageData.lastPrice) / (((_data || {} || {}).P1 || {}).YearProfit * 100000000),
          tip: '总市值/最新年报披露的净利润',
          fixed: 2
        },
        {
          key: '',
          name: '总市值 (元)',
          num: ((_data || {} || {}).P1 || {}).TotalShares * pageData.lastPrice,
          slots: { customRender: 'peopleCount' }
        },
        {
          key: '',
          name: '流通市值 (元)',
          num: ((_data || {} || {}).P1 || {}).FloatShare * pageData.lastPrice,
          slots: { customRender: 'peopleCount' }
        },
        {
          key: '',
          name: '市净率 (%)',
          num: pageData.lastPrice / ((_data || {} || {}).P2 || {}).NAPS,
          tip: '最新价/每股净资产',
          fixed: 2
        },
      ]
      pageData.spinning = false
      return list
    }
    pageData.list2 = computed(() => {
      return setlist2()
    })
    function setlist2() {
      const _data = (props.pageSourceData || {}).Fin
      if (!(_data || {}).P4) return
      pageData.EndDate1 = ((_data || {} || {}).P7 || {}).EndDate
      pageData.spinning = false
      return [
        {
          key: '',
          name: '加权净资产收益率',
          num: ((_data || {} || {}).P4 || {}).WROE,
          num0: ((_data || {} || {}).P4 || {}).WROE0,
          tag: _data.P4.Tag === 1 ? '快' : null,
          time: _data.P4.EndDate
        },
        {
          key: '',
          name: '毛利率',
          num: ((_data || {} || {}).P5 || {}).GrossIncomeRatio,
          num0: ((_data || {} || {}).P5 || {}).GrossIncomeRatio0,
          tag: _data.P5.Tag === 1 ? '快' : null,
          time: _data.P5.EndDate
        },
        {
          key: '',
          name: '资产负债率',
          num: ((_data || {} || {}).P5 || {}).DebtAssetsRatio,
          num0: ((_data || {} || {}).P5 || {}).DebtAssetsRatio0,
          tag: _data.P5.Tag === 1 ? '快' : null,
          time: _data.P5.EndDate
        },
        {
          key: '',
          name: '营业总收入 (元)',
          num: ((_data || {} || {}).P6 || {}).OperatingReenue,
          num0: ((_data || {} || {}).P6 || {}).OperatingReenue0,
          tag: _data.P6.Tag === 1 ? '快' : null,
          time: _data.P6.EndDate,
          slots: { customRender: 'peopleCount' }
        },
        {
          key: '',
          name: '营业总收入滚动环比增长',
          num: ((_data || {} || {}).P7 || {}).OPR,
          num0: ((_data || {} || {}).P7 || {}).OPR0
        },
        {
          key: '',
          name: '营业总收入同比增长',
          num: ((_data || {} || {}).P4 || {}).ORYOY,
          num0: ((_data || {} || {}).P4 || {}).ORYOY0,
          tag: _data.P4.Tag === 1 ? '快' : null,
          time: _data.P4.EndDate
        },
        {
          key: '',
          name: '归属净利润 (元)',
          num: ((_data || {} || {}).P6 || {}).NPFromParentCompanyOwners,
          num0: ((_data || {} || {}).P6 || {}).NPFromParentCompanyOwners0,
          tag: _data.P6.Tag === 1 ? '快' : null,
          time: _data.P6.EndDate,
          slots: { customRender: 'peopleCount' }
        },
        {
          key: '',
          name: '归属净利润滚动环比增长',
          num: ((_data || {} || {}).P7 || {}).NPPR,
          num0: ((_data || {} || {}).P7 || {}).NPPR0
        },
        {
          key: '',
          name: '归属净利润同比增长',
          num: ((_data || {} || {}).P4 || {}).NPCOwnersYOY,
          num0: ((_data || {} || {}).P4 || {}).NPCOwnersYOY0,
          tag: _data.P4.Tag === 1 ? '快' : null,
          time: _data.P4.EndDate
        },
        {
          key: '',
          name: '扣非净利润 (元)',
          num: ((_data || {} || {}).P6 || {}).NetProfitCut,
          num0: ((_data || {} || {}).P6 || {}).NetProfitCut0,
          tag: _data.P6.Tag === 1 ? '快' : null,
          time: _data.P6.EndDate,
          slots: { customRender: 'peopleCount' }
        },
        {
          key: '',
          name: '扣非净利润滚动环比增长',
          num: ((_data || {} || {}).P8 || {}).CNPPR,
          num0: ((_data || {} || {}).P8 || {}).CNPPR0
        },
        {
          key: '',
          name: '扣非净利润同比增长',
          num: ((_data || {} || {}).P4 || {}).NetProfitCutYOY,
          num0: ((_data || {} || {}).P4 || {}).NetProfitCutYOY0,
          tag: _data.P4.Tag === 1 ? '快' : null,
          time: _data.P4.EndDate
        }
      ]
    }
    function isoverflow(e: any, index: number) {
      const text = e.target.outerText
      pageData.tooltip[text] = e.currentTarget.scrollWidth > e.currentTarget.clientWidth
      if (pageData.tooltip[text]) {
        pageData.overflow[text + index] = true
      }
    }
    function hidetool(index: number, text: string) {
      pageData.overflow[text + index] = false
    }
    onMounted(() => {
      if (route.query.code && route.query.market) {
        console.log('重新监听===', route.query.code, route.query.market)
        ws.websocket.safeSubscribeDYNA(route.query.code, route.query.market)
        ws.websocket.on('onDYNA', msg => {
          console.log('打印数据====```', pageData.lastPrice)
          const _data = msg.QuoteData
          // 停牌
          if (_data.DynaData[0].InstStatus === 6) {
            pageData.lastPrice = null
          } else {
            if (_data && _data.DynaData && (_data.DynaData || []).length > 0) {
              pageData.lastPrice = _data.DynaData[0].LastPrice || null
              console.log('打印数据====', pageData.lastPrice)
            }
          }
        })
      }
      console.log(pageData.lastPrice, '========')
    })
    onUnmounted(() => {
      ws.websocket.safeUnsubscribeDYNA(route.query.code, route.query.market)
    })

    return {
      ...toRefs(pageData),
      isoverflow,
      hidetool,
      moment: window.moment,
      setquarter: globalsets.setquarter
    }
  }
})
